/** The non-blank rows of a RowsInput, trimmed. */
export const filled = (rows: string[]) => rows.map((x) => x.trim()).filter(Boolean);
